import React from "react";
import { Primitive } from "@radix-ui/react-primitive";

type ButtonProps =
  | {
      children: React.ReactNode;
      onClick: () => void;
      variant?: "primary" | "secondary";
      type?: never;
      disabled?: boolean;
      width?: string;
    }
  | {
      children: React.ReactNode;
      onClick?: never;
      variant?: "primary" | "secondary";
      type: "submit";
      disabled?: boolean;
      width?: string;
    };

const Button: React.FC<ButtonProps> = ({ children, onClick, variant = "primary", type, disabled, width }) => {
  const variantClasses =
    variant === "primary"
      ? disabled
        ? "bg-accent text-white"
        : "bg-accent text-white hover:bg-accent-dark"
      : disabled
      ? "bg-primary text-white"
      : "bg-primary text-white hover:bg-primary-dark";
  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <Primitive.button
      className={`m-2 px-4 py-2 rounded font-display font-semibold focus:outline-none ${width} ${variantClasses} ${disabledClasses}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </Primitive.button>
  );
};

export default Button;
